import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import Faq from '../../../components/Faq';
import typesLottie from '../../../public/images/types.json';
import Why from '../../../components/Why';
import ViewMore from '../../../components/ViewMore';
import BenefitsProduct from '../../../components/video-production/explainer-videos/BenefitsProduct';
import ProcessSliderProduct from '../../../components/sliders/ProcessSliderProduct';
import SolveProblemsProduct from '../../../components/video-production/explainer-videos/SolveProblemsProduct';

lazyload({
  width: '100%',
});

const ExplainerVideosProduct = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - Product Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/product-explainer-video" />
        <meta
          name="description"
          content="Discover the power of our product with an informative explainer video. Explore its features and benefits effortlessly. Dive in now."
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/product-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - Product Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Discover the power of our product with an informative explainer video. Explore its features and benefits effortlessly. Dive in now."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/product-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
              "@context": "http://schema.org",
              "@type": "WebPage",
              "name": "Video Production - Product Explainer Video | Prodigi",
              "description": "Discover the power of our product with an informative explainer video. Explore its features and benefits effortlessly. Dive in now.",
              "url": "https://weprodigi.com/video-production/product-explainer-video",
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://weprodigi.com"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Full Service Video Production",
                    "item": "https://weprodigi.com/video-production"
                  },
                  {
                    "@type": "ListItem",
                    "position": 3,
                    "name": "Product Explainer Video Production - Prodigi",
                    "item": "https://weprodigi.com/video-production/product-explainer-video"
                  }
                ]
              },
              "mainEntity": {
                "@type": "Product",
                "name": "Product Explainer Video Production",
                "description": "Discover the power of our product with an informative explainer video. Explore its features and benefits effortlessly. Dive in now.",
                "brand": {
                  "@type": "Brand",
                  "name": "Weprodigi"
                },
                "offers": {
                  "@type": "Offer",
                  "price": "1300",
                  "priceCurrency": "USD",
                  "seller": {
                    "@type": "Organization",
                    "name": "Weprodigi"
                  }
                },
                "image": "https://weprodigi.com/images/logovertical.svg",
                "review": [
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Dana Hart"
                    },
                    "datePublished": "2023-02-4",
                    "reviewBody": "Prodigi has truly outdone themselves with our Product explainer Video. It's not only visually appealing but also effectively conveys our message in a captivating manner. I couldn't be happier with the outcome. Thank you for your hard work!"
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Cindy Beckett"
                    },
                    "datePublished": "2023-10-23",
                    "reviewBody": "Prodigi's Product explainer video has exceeded my expectations. The attention to detail and seamless animation truly impressed me. It's an excellent tool for engaging our audience and boosting our brand visibility."
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "4.9",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Lily Wilson"
                    },
                    "datePublished": "2024-03-7",
                    "reviewBody": "I had high expectations for our Explainer Video, and Prodigi surpassed them all.Thank You!"
                  }
                ],
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.9",
                  "reviewCount": "3"
                }
              }
            }                        
            `,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src="https://weprodigi.com/uploads/images/explainer-videos/product-explainer/product-explainer.mp4" type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              Product Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/product-explainer-video',
                name: 'Product Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  A product explainer video will provide the green light on the way of succeeding your product. Collaborating digital storytelling
                  with an eye-catching visualization will make your product noticeable and competitive in diverse markets. Scroll to discover how.
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full lg:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What Is a Product Explainer Video?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/UHCqHK84izk?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Geogroup | Manufacturing Explainer Video</p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                A Product explainer video is a short, engaging video clip. Generally lasting between 1 to 3 minutes, it gives a clear and concise
                explanation of the product’s features, benefits, and particular problem solutions. Creative video production illustrates the
                importance of your product, encouraging viewers to take a specific step next to try it. As a great marketing tool, it can clarify
                tough concepts about your product to improve customer experience.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  A Product explainer video is a short, engaging video clip. Generally lasting between 1 to 3 minutes, it gives a clear and concise
                  explanation of the product’s features, benefits, and particular problem solutions. Creative video production illustrates the
                  importance of your product, encouraging viewers to take a specific step next to try it. As a great marketing tool, it can clarify
                  tough concepts about your product to improve customer experience.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where to Use Product Explainer Video?
            </h2>
            <p className={'mt-20'}>
              What can a product explainer video do for you that no other tool can? Discover the best benefits for your industry.
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/VhdtnILFCG0?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>HME | Manufacturing Product Explainer</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  Do you want your call to action to hit the target? Product video service is your improved vision. It makes it easy to engage new
                  customers and reserve your spot in the market. Use our animated storytelling format in social media ads, landing pages, e-commerce
                  or retail platforms, email marketing, etc. Leave a beautifully visualized impact.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Do you want your call to action to hit the target? Product video service is your improved vision. It makes it easy to engage new
                    customers and reserve your spot in the market. Use our animated storytelling format in social media ads, landing pages, e-commerce
                    or retail platforms, email marketing, etc. Leave a beautifully visualized impact.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Business Startups</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  Have you ever wondered how to introduce your startup, addressing a real market need? Product video services are here to guide you in
                  the right direction. Creative video production serves as an invaluable tool for visualized communication of the value of the
                  innovations of your startup. Using a strategic explainer video will elevate the product’s market presence. Ensure your growth
                  creatively.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Have you ever wondered how to introduce your startup, addressing a real market need? Product video services are here to guide you
                    in the right direction. Creative video production serves as an invaluable tool for visualized communication of the value of the
                    innovations of your startup. Using a strategic explainer video will elevate the product’s market presence. Ensure your growth
                    creatively.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/Hg6rpRCfbW0?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Smartrix | Manufacturing Product Explainer</p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/GcfJTZiAmd4?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Status Cards | Financial Product Explainer</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Finance and Banking</h3>
                <p className={'mt-16 hidden md:block'}>
                  Are you looking for a possibility to make your customer onboarding process smoother? The product explainer video format is here to
                  do it for you. Its lively visualized format allows you to simplify your complex product explanations. Letting your customers clearly
                  understand your features and benefits will build strong client relationships. Break the barrier of ignorance using an impactful
                  approach.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    Are you looking for a possibility to make your customer onboarding process smoother? The product explainer video format is here to
                    do it for you. Its lively visualized format allows you to simplify your complex product explanations. Letting your customers
                    clearly understand your features and benefits will build strong client relationships. Break the barrier of ignorance using an
                    impactful approach.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Benefits of Product Explainer Videos
            </h2>
            <p className={'mt-20'}>
              Imagine how fascinating it can become the introduction of your brand awareness. Tell your brand story with different visualizations by
              live-action or animated explainer video production. Explainer videos are ready to give a unique signature to your brand and create a
              catchy wave of new engagement. The main benefits are below.
            </p>
            <Suspense fallback={`Loading...`}>
              <BenefitsProduct />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Our Product Explainer Video Production Process
            </h2>
            <ProcessSliderProduct />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div
              className={
                'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-26 lg:text-36'
              }
            >
              CALCULATE YOUR PRODUCT EXPLAINER VIDEO PRICE
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How Product Explainer Video Can Help Your Business?
            </h2>
            <p className={'mt-20'}>
              Do you know what your audience wants in a product or service? If so, now is a great time to use the power of a product explainer video
              for your business.
            </p>
            <Suspense fallback={`Loading...`}>
              <SolveProblemsProduct />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">
              Why Choose Us for Your Product Explainer Video Production?
            </h2>
            <Why
              content={[
                {
                  title: 'We ensure technical superiority.',
                  answer:
                    'Our experienced specialists work only with the most contemporary cameras, sound, and light devices to provide the highest quality of your video. ',
                },
                {
                  title: 'We provide a creative approach.',
                  answer:
                    'Mixing the flexibility of video format and the creativity of our experienced company makes it possible to add originality to your offer. Our enthusiastic video production team can provide an individual approach to your product explainer videos, visualizing the main points differently. ',
                },
                {
                  title: 'We manage the entire project.',
                  answer:
                    'Our professional project management team will coordinate all the operations and guarantee the necessary communication. Handling the project plan guarantees that your business goals will be completed on time. In addition, with our digital marketing specialists’ help, we’ll find the most useful online platforms for your video. ',
                },
                {
                  title: 'We provide customized solutions.',
                  answer:
                    'A strong analysis of the significance of your brand allows us to make explainer videos that perfectly show your brand’s uniqueness and character. Our personalization ensures that your video creates a bond with your audience and echoes a creative call for action. ',
                },
                {
                  title: 'We don’t require prepayment. ',
                  answer:
                    'We chose the milestone payment approach for our 30-second explainer video services because we are sure it offers the best benefits for our team and clients.',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'How long should a product explainer video be?',
                    answer:
                      'As a rule, product explainer videos last from 1 to 3 minutes. They give a clear explanation of a product’s features, benefits, and particular problem solutions in that timeline. ',
                  },
                  {
                    title: 'Are explainer videos profitable? ',
                    answer:
                      'Explainer videos are one of the most useful marketing strategies for businesses today. They are also very attractive and engaging; due to eye-catching content, they are one of the most needed marketing tools.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'How long does it take to make a product video? ',
                    answer:
                      'It generally takes 4-6 weeks to make a product video production. While  the project’s volume and the video’s chosen style also matter.',
                  },
                  {
                    title: 'How can I measure the effectiveness of my product explainer video? ',
                    answer:
                      'You can measure the play rate of your video by dividing the number of video plays by the number of page visits. This instruction will let you automatically follow play rates through the analytics tools provided by the host platform of your video.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideosProduct;
